<template>
    <div class="modal fade" tabindex="-1" role="dialog" id="settings-modal">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <form @submit.prevent="submit">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">
                                &times;
                            </span>
                        </button>

                        <h4 class="modal-title">
                            Select Metrics
                        </h4>
                    </div>

                    <div class="modal-body">
                        <select-form-group
                            v-model="data.first"
                            name="first"
                            label="Metric 1"
                            :error="getError('first')"
                            :options="metrics"
                        />

                        <select-form-group
                            v-model="data.second"
                            name="second"
                            label="Metric 2"
                            :error="getError('second')"
                            :options="metrics"
                        />

                        <date-form-group
                            v-model="filterValues.created_from"
                            name="created_from"
                            label="Created From"
                            :error="getError('created_from')"
                        />

                        <date-form-group
                            v-model="filterValues.created_to"
                            name="created_to"
                            label="Created To"
                            :error="getError('created_to')"
                        />
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">
                            Close
                        </button>

                        <button type="submit" class="btn btn-black">
                            <i class="fa fa-save"></i> Save
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import DateFormGroup from '@/vendor/forms/FormGroups/Block/Date'
import Errors from '@/mixins/Errors'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'

export default {
    components: {DateFormGroup, SelectFormGroup},

    mixins: [Errors],

    props: {
        value: {
            required: true,
            type: Object
        },

        metrics: {
            required: true
        },

        filters: {
            required: true,
            type: Object
        }
    },

    data() {
        return {
            data: {...this.value},
            filterValues: {...this.filters}
        }
    },

    mounted() {
        $(this.$el).on('hidden.bs.modal', () => {
            this.filterValues = {...this.filters}
        })
    },

    watch: {
        value() {
            this.data = {...this.value}
        },

        filters() {
            this.filterValues = {...this.filters}
        }
    },

    methods: {
        submit() {
            this.$emit('input', this.data)

            this.$emit('update:filters', this.filterValues)

            $(this.$el).modal('hide')
        }
    }
}
</script>
